<template>
  <div class="app-container">
    <list ref="list">
        
        <template slot="column">
            <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
            <el-table-column label="操作" fixed="right" align="center" width="160">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite()" type="text" @click="edit(row)">编辑</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/clothmanagement/cloth/list'
// import editDialog from '@/components/production/clothmanagement/cloth/editDialog'

export default {
  name: "cloth",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog
  },
  methods: {
    delRows(){

    },
    
  }
  
};
</script>